(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [
		{name:"capa_atlas_1", frames: [[0,0,554,210]]}
];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.logoSeven = function() {
	this.initialize(ss["capa_atlas_1"]);
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.animaLogo = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_24 = function() {
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(24).call(this.frame_24).wait(1));

	// Camada_2 (mask)
	var mask = new cjs.Shape();
	mask._off = true;
	var mask_graphics_1 = new cjs.Graphics().moveTo(-58.5,52).lineTo(-58.5,-52).lineTo(58.5,-52).lineTo(58.5,52).closePath();
	var mask_graphics_3 = new cjs.Graphics().moveTo(-115,52).lineTo(-115,-52).lineTo(115,-52).lineTo(115,52).closePath();
	var mask_graphics_5 = new cjs.Graphics().moveTo(-177.5,52).lineTo(-177.5,-52).lineTo(177.5,-52).lineTo(177.5,52).closePath();
	var mask_graphics_7 = new cjs.Graphics().moveTo(-238,52).lineTo(-238,-52).lineTo(238,-52).lineTo(238,52).closePath();
	var mask_graphics_9 = new cjs.Graphics().moveTo(-296.5,52).lineTo(-296.5,-52).lineTo(296.5,-52).lineTo(296.5,52).closePath();
	var mask_graphics_11 = new cjs.Graphics().moveTo(-294.5,97.5).lineTo(-294.5,14.5).lineTo(-190.5,14.5).lineTo(-190.5,97.5).closePath().moveTo(-296.5,6.5).lineTo(-296.5,-97.5).lineTo(296.5,-97.5).lineTo(296.5,6.5).closePath();
	var mask_graphics_13 = new cjs.Graphics().moveTo(-294.5,97.5).lineTo(-294.5,14.5).lineTo(-120.5,14.5).lineTo(-120.5,97.5).closePath().moveTo(-296.5,6.5).lineTo(-296.5,-97.5).lineTo(296.5,-97.5).lineTo(296.5,6.5).closePath();
	var mask_graphics_15 = new cjs.Graphics().moveTo(-294.5,97.5).lineTo(-294.5,14.5).lineTo(-1.5,14.5).lineTo(-1.5,97.5).closePath().moveTo(-296.5,6.5).lineTo(-296.5,-97.5).lineTo(296.5,-97.5).lineTo(296.5,6.5).closePath();
	var mask_graphics_17 = new cjs.Graphics().moveTo(-294.4,97.5).lineTo(-294.4,14.5).lineTo(60.6,14.5).lineTo(60.6,97.5).closePath().moveTo(-296.5,6.5).lineTo(-296.5,-97.5).lineTo(296.5,-97.5).lineTo(296.5,6.5).closePath();
	var mask_graphics_19 = new cjs.Graphics().moveTo(-294.4,97.5).lineTo(-294.4,14.5).lineTo(177.6,14.5).lineTo(177.6,97.5).closePath().moveTo(-296.5,6.5).lineTo(-296.5,-97.5).lineTo(296.5,-97.5).lineTo(296.5,6.5).closePath();
	var mask_graphics_21 = new cjs.Graphics().moveTo(-294.9,97.5).lineTo(-294.9,14.5).lineTo(297.1,14.5).lineTo(297.1,97.5).closePath().moveTo(-297.1,6.5).lineTo(-297.1,-97.5).lineTo(296,-97.5).lineTo(296,6.5).closePath();
	var mask_graphics_23 = new cjs.Graphics().moveTo(-163.1,122.5).lineTo(-163.1,72.5).lineTo(-294.9,72.5).lineTo(-294.9,-10.5).lineTo(297.1,-10.5).lineTo(297.1,72.5).lineTo(296.9,72.5).lineTo(296.9,122.5).closePath().moveTo(-297.1,-18.5).lineTo(-297.1,-122.5).lineTo(296,-122.5).lineTo(296,-18.5).closePath();

	this.timeline.addTween(cjs.Tween.get(mask).to({graphics:null,x:0,y:0}).wait(1).to({graphics:mask_graphics_1,x:-245.6,y:-72.05}).wait(2).to({graphics:mask_graphics_3,x:-189.1,y:-72.05}).wait(2).to({graphics:mask_graphics_5,x:-126.6,y:-72.05}).wait(2).to({graphics:mask_graphics_7,x:-66.1,y:-72.05}).wait(2).to({graphics:mask_graphics_9,x:-7.575,y:-72.05}).wait(2).to({graphics:mask_graphics_11,x:-7.575,y:-26.55}).wait(2).to({graphics:mask_graphics_13,x:-7.575,y:-26.55}).wait(2).to({graphics:mask_graphics_15,x:-7.575,y:-26.55}).wait(2).to({graphics:mask_graphics_17,x:-7.575,y:-26.55}).wait(2).to({graphics:mask_graphics_19,x:-7.575,y:-26.55}).wait(2).to({graphics:mask_graphics_21,x:-7.025,y:-26.55}).wait(2).to({graphics:mask_graphics_23,x:-7.025,y:-1.55}).wait(2));

	// AnimacaoLogo
	this.instance = new lib.logoSeven();
	this.instance.setTransform(-277,-105);
	this.instance._off = true;

	var maskedShapeInstanceList = [this.instance];

	for(var shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
		maskedShapeInstanceList[shapedInstanceItr].mask = mask;
	}

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).wait(24));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-277,-105,554,210);


// stage content:
(lib.capa = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {frame01:1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this.actionFrames = [0,1];
	// timeline functions:
	this.frame_0 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
		
		const loadController = () => {
		    if (typeof (window.parent.AllTap) !== 'undefined') {
		        /**
		         *
		         * Class reference.
		         */
		        const
		            AllTapParent = window.parent.AllTap,
		            name_current = 'capa';
		
		        /**
		         *
		         *  @param object
		         *  Set "this", object of canvas CreateJs.
		         */
		        AllTapParent.setState({...AllTapParent.state, [`_this_${name_current}`]: this});
			
				this.gotoAndStop('frame01');
		
		        createjs.Ticker.removeEventListener('tick', loadController);
		    }
		};
		
		createjs.Ticker.addEventListener('tick', loadController);
	}
	this.frame_1 = function() {
		/**
		 *
		 *  Stop the movie clip.
		 */
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1));

	// ContentFrame
	this.instance = new lib.animaLogo();
	this.instance.setTransform(942.95,487.95,1.2605,1.2605,0,0,0,0.1,0.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);
// library properties:
lib.properties = {
	id: '0FBEFCCB6FA99240974BF4F7DBA4F13D',
	width: 1920,
	height: 1080,
	fps: 30,
	color: "#FFFFFF",
	opacity: 0.00,
	manifest: [
		{src:"images/capa_atlas_1.png", id:"capa_atlas_1"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['0FBEFCCB6FA99240974BF4F7DBA4F13D'] = {
	getStage: function() { return exportRoot.stage; },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}


an.makeResponsive = function(isResp, respDim, isScale, scaleType, domContainers) {		
	var lastW, lastH, lastS=1;		
	window.addEventListener('resize', resizeCanvas);		
	resizeCanvas();		
	function resizeCanvas() {			
		var w = lib.properties.width, h = lib.properties.height;			
		var iw = window.innerWidth, ih=window.innerHeight;			
		var pRatio = window.devicePixelRatio || 1, xRatio=iw/w, yRatio=ih/h, sRatio=1;			
		if(isResp) {                
			if((respDim=='width'&&lastW==iw) || (respDim=='height'&&lastH==ih)) {                    
				sRatio = lastS;                
			}				
			else if(!isScale) {					
				if(iw<w || ih<h)						
					sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==1) {					
				sRatio = Math.min(xRatio, yRatio);				
			}				
			else if(scaleType==2) {					
				sRatio = Math.max(xRatio, yRatio);				
			}			
		}
		domContainers[0].width = w * pRatio * sRatio;			
		domContainers[0].height = h * pRatio * sRatio;
		domContainers.forEach(function(container) {				
			container.style.width = w * sRatio + 'px';				
			container.style.height = h * sRatio + 'px';			
		});
		stage.scaleX = pRatio*sRatio;			
		stage.scaleY = pRatio*sRatio;
		lastW = iw; lastH = ih; lastS = sRatio;            
		stage.tickOnUpdate = false;            
		stage.update();            
		stage.tickOnUpdate = true;		
	}
}
an.handleSoundStreamOnTick = function(event) {
	if(!event.paused){
		var stageChild = stage.getChildAt(0);
		if(!stageChild.paused || stageChild.ignorePause){
			stageChild.syncStreamSounds();
		}
	}
}
an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
var createjs, AdobeAn;